import { useAuthInfo } from '@propelauth/react';

function GreetingMessage() {
  const userInfo = useAuthInfo();

  const currentHour = new Date().getHours();
  const greeting =
    currentHour >= 5 && currentHour < 12 ? 'Good morning'
    : currentHour >= 12 && currentHour < 17 ? 'Good afternoon'
    : 'Good evening';

  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-50">
        {greeting}
        {userInfo.user?.firstName ? `, ${userInfo.user.firstName}` : ''}
      </h1>
    </div>
  );
}

export default GreetingMessage;
